/* ============================================================
   PureLabs Reviews Drawer — section runtime
   Default closed. Opens when a shopper clicks the score text
   (e.g. "4.8 · 621 reviews"). Builds 20 reviews from the card
   template, with rating filter, with-media, show-more, pagination.
   ============================================================ */
(function () {
  function init() {
    var roots = document.querySelectorAll('[data-reviews-drawer]');
    if (!roots.length) return;
    // keep a single instance if the section was added more than once
    for (var r = roots.length - 1; r >= 1; r--) roots[r].remove();
    var root = roots[0];
    // move the whole scope to <body> so position:fixed is viewport-relative
    // even if a GemPages ancestor has a transform/filter/will-change
    if (root.parentElement !== document.body) document.body.appendChild(root);
    var portal = root.querySelector('.chakra-portal');
    if (!portal) return;
    portal.style.display = 'none';

    var triggerWord = (root.getAttribute('data-trigger') || 'reviews').trim() || 'reviews';
    // accept the configured word(s) plus common EN/NL review words, so the score text
    // opens the drawer whether it says "reviews", "beoordelingen", "recensies", etc.
    var TRIG_WORDS = [];
    triggerWord.toLowerCase().split(/[,\s]+/).forEach(function (w) { if (w) TRIG_WORDS.push(w); });
    ['review', 'reviews', 'beoordeling', 'beoordelingen', 'recensie', 'recensies', 'vertrouwde', 'waardering'].forEach(function (w) { if (TRIG_WORDS.indexOf(w) === -1) TRIG_WORDS.push(w); });
    // matches if the text is short, has a number AND contains any review word
    function TRIG_TEST(t) {
      t = (t || '').trim();
      if (!t || t.length > 60 || !/\d/.test(t)) return false;
      var lt = t.toLowerCase();
      for (var i = 0; i < TRIG_WORDS.length; i++) { if (lt.indexOf(TRIG_WORDS[i]) !== -1) return true; }
      return false;
    }
    var TRIG_RE = { test: TRIG_TEST };
    var RECO = (root.getAttribute('data-score-recommend') || '').trim();
    // per-product on-page score line, e.g. "4.7 · 429 reviews" (overrides the GemPages text)
    var SCORE_TEXT = (root.getAttribute('data-score-text') || '').trim();
    // force the on-page score text + recommend onto a trigger element, and keep it stable
    function applyScore(el) {
      if (SCORE_TEXT) {
        var want = SCORE_TEXT + (RECO ? ' · ' + RECO : '');
        if ((el.textContent || '').trim() !== want) {
          el.textContent = SCORE_TEXT;
          if (RECO) {
            var rs = document.createElement('span');
            rs.className = 'rv-reco';
            rs.textContent = ' · ' + RECO;
            el.appendChild(rs);
          }
        }
      } else if (RECO && (el.textContent || '').indexOf('%') === -1 && !el.querySelector('.rv-reco')) {
        var rs2 = document.createElement('span');
        rs2.className = 'rv-reco';
        rs2.textContent = ' · ' + RECO;
        el.appendChild(rs2);
      }
    }

    // de-dupe drawer panels / backdrops captured by the scrape
    var panels = portal.querySelectorAll('.css-1v6vmmu');
    for (var i = 1; i < panels.length; i++) panels[i].remove();
    var backs = portal.querySelectorAll('.css-1pikkt7');
    for (var b = 1; b < backs.length; b++) backs[b].remove();

    var drawer = portal.querySelector('.css-1v6vmmu');
    if (!drawer) return;

    var scrollLock = function (on) { document.documentElement.style.overflow = on ? 'hidden' : ''; document.body.style.overflow = on ? 'hidden' : ''; };
    function isOpen() { return portal.style.display !== 'none'; }
    function openDrawer() {
      portal.style.setProperty('display', 'block', 'important');
      scrollLock(true);
      var sa = drawer.querySelector('.css-1lyuty0'); if (sa) sa.scrollTop = 0;
    }
    function closeDrawer() {
      portal.style.setProperty('display', 'none', 'important');
      scrollLock(false);
    }

    // direct binding to every close button + backdrop
    function bindClose() {
      root.querySelectorAll('[aria-label="Close reviews"]').forEach(function (b) {
        if (b.__rvc) return; b.__rvc = 1;
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); closeDrawer(); });
      });
      portal.querySelectorAll('.css-1pikkt7').forEach(function (bd) {
        if (bd.__rvc) return; bd.__rvc = 1;
        bd.addEventListener('click', function () { closeDrawer(); });
      });
    }
    bindClose();
    // backup: capture-phase delegation so nothing on the page can swallow the click
    document.addEventListener('click', function (e) {
      if (!isOpen() || !root.contains(e.target)) return;
      if (e.target.closest('[aria-label="Close reviews"]')) { e.preventDefault(); e.stopPropagation(); closeDrawer(); return; }
      if (e.target.classList && e.target.classList.contains('css-1pikkt7')) { closeDrawer(); }
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) closeDrawer(); });

    // ---- use the server-rendered review cards (one card per section block) ----
    var cards = Array.prototype.slice.call(drawer.querySelectorAll('[data-rv-card]'));
    if (!cards.length) { cards = Array.prototype.slice.call(drawer.querySelectorAll('.css-1p7euut')); }
    if (cards.length) {
      var PER = parseInt(root.getAttribute('data-per-page'), 10) || 4;
      var page = 1, ratingFilter = null;
      var pageWrap = drawer.querySelector('.css-70qvj9');
      var pagerNav = drawer.querySelector('.css-1xg20uj');
      var prevBtn = drawer.querySelector('[aria-label="Previous page"]');
      var nextBtn = drawer.querySelector('[aria-label="Next page"]');
      var scrollArea = drawer.querySelector('.css-1lyuty0') || drawer;

      // add a show-more clamp to each real card's body
      cards.forEach(function (card) {
        var bd = card.querySelector('p.css-n68aj4');
        if (!bd || bd.__rvclamp) return; bd.__rvclamp = 1;
        bd.classList.add('rv-clamp');
        var more = document.createElement('button');
        more.type = 'button'; more.className = 'css-r2h2m0 rv-more'; more.textContent = 'Lees meer'; more.style.marginTop = '6px';
        more.addEventListener('click', function () { var cl = bd.classList.toggle('rv-clamp'); more.textContent = cl ? 'Lees meer' : 'Lees minder'; });
        bd.insertAdjacentElement('afterend', more);
        requestAnimationFrame(function () { if (bd.scrollHeight <= bd.clientHeight + 2) more.style.display = 'none'; });
      });

      function filtered() { return cards.filter(function (c) { return !ratingFilter || +c.getAttribute('data-rating') === ratingFilter; }); }
      function renderPager(pages) {
        if (pagerNav) pagerNav.style.display = pages <= 1 ? 'none' : '';
        if (!pageWrap) return;
        pageWrap.innerHTML = '';
        if (pages <= 1) { if (prevBtn) prevBtn.style.display = 'none'; if (nextBtn) nextBtn.style.display = 'none'; return; }
        if (prevBtn) prevBtn.style.display = ''; if (nextBtn) nextBtn.style.display = '';
        for (var n = 1; n <= pages; n++) {
          (function (n) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'chakra-text ' + (n === page ? 'css-1jupeeb' : 'css-1s8lalf');
            btn.setAttribute('aria-label', 'Page ' + n);
            btn.textContent = n;
            btn.addEventListener('click', function () { page = n; apply(); });
            pageWrap.appendChild(btn);
          })(n);
        }
      }
      function apply() {
        var fc = filtered();
        var pages = Math.max(1, Math.ceil(fc.length / PER));
        if (page > pages) page = pages; if (page < 1) page = 1;
        cards.forEach(function (c) { c.classList.add('rv-hide'); });
        fc.slice((page - 1) * PER, page * PER).forEach(function (c) { c.classList.remove('rv-hide'); });
        renderPager(pages);
        if (scrollArea && scrollArea.scrollTo) scrollArea.scrollTo({ top: 0, behavior: 'smooth' });
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { if (page > 1) { page--; apply(); } });
      if (nextBtn) nextBtn.addEventListener('click', function () { page++; apply(); });

      // rating dropdown (reuse the Chakra menu, anchored under the button)
      var label = drawer.querySelector('.css-xl71ch');
      var labelDefault = label ? label.textContent.trim() : 'All ratings';
      var menuBtn = label ? label.closest('button') : null;
      var popper = drawer.querySelector('.css-l1a2g3');
      var menuList = drawer.querySelector('.css-27fczc');
      function setMenu(open) {
        if (!popper || !menuList) return;
        if (open && menuBtn) {
          var r = menuBtn.getBoundingClientRect();
          popper.style.position = 'fixed'; popper.style.inset = 'auto';
          popper.style.top = (r.bottom + 4) + 'px'; popper.style.left = r.left + 'px'; popper.style.zIndex = '2147483647';
        }
        popper.style.visibility = open ? 'visible' : 'hidden';
        menuList.style.opacity = open ? '1' : '0';
        menuList.style.visibility = open ? 'visible' : 'hidden';
        menuList.style.transform = open ? 'none' : 'scale(0.8)';
        menuList.style.transformOrigin = 'top left';
        if (menuBtn) menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      if (menuBtn) {
        menuBtn.addEventListener('click', function (e) { e.stopPropagation(); setMenu(popper && popper.style.visibility !== 'visible'); });
        document.addEventListener('click', function () { setMenu(false); });
        drawer.querySelectorAll('[role="menuitem"]').forEach(function (item) {
          item.addEventListener('click', function () {
            var txt = item.textContent.trim();
            var mm = txt.match(/^([1-5])\s*(?:star|ster)/i);
            ratingFilter = mm ? +mm[1] : null;
            if (label) label.textContent = mm ? txt : labelDefault;
            page = 1; setMenu(false); apply();
          });
        });
      }
      var mediaBtn = Array.prototype.slice.call(drawer.querySelectorAll('button')).find(function (b) { return /with media/i.test(b.textContent.trim()); });
      if (mediaBtn) mediaBtn.addEventListener('click', function () { mediaBtn.classList.toggle('rv-active'); });

      apply();
    }

    // ---- wire the on-page score text to open the drawer ----
    function wireTriggers(scope) {
      var nodes = (scope || document).querySelectorAll('p,span,a,div,button,strong,h1,h2,h3,h4');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (root.contains(el)) continue;
        var txt = (el.textContent || '').trim();
        if (txt.length > 45 || !TRIG_RE.test(txt)) continue;
        var childMatch = false;
        for (var c = 0; c < el.children.length; c++) { if (TRIG_RE.test(el.children[c].textContent || '')) { childMatch = true; break; } }
        if (childMatch) continue;
        // keep the on-page score text/recommend correct every scan (so a GemPages
        // re-render can't revert it, duplicate it, or break the layout)
        applyScore(el);
        if (el.__rvBound) continue;
        el.__rvBound = true;
        el.style.cursor = 'pointer';
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
        el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openDrawer(); } });
      }
    }
    try { console.log('[reviews-drawer] v9 ready (dynamic blocks) — close+pagination+filter wired'); } catch (e) {}
    function run() { wireTriggers(document); }
    run();
    [400, 1200, 2500, 4500].forEach(function (t) { setTimeout(run, t); });
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { run(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 12000);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
